import { sharedService } from "@/modules/shared/store/services/shared-service";
import { populateMortgageIndexes } from "@/redux/reducers/morgateIndexes";

const getMortgageIndexes = sharedService.injectEndpoints({
  endpoints: builder => ({
    getMortgageIndexes: builder.query({
      query: () => "parameters/mortgage-indexes",
      transformResponse: response => response.items,
      providesTags: ["MortgageIndexes"],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(populateMortgageIndexes(data));
        } catch { /* handled by RTK Query error state */ }
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetMortgageIndexesQuery } = getMortgageIndexes;

